// ==========================================================================
// Oli — Chatbot popup + Greeting screen drawer
// ==========================================================================

(function () {

  // ===== Chatbot Floating Widget =====

  var trigger = document.getElementById('oli-chatbot-trigger');
  var popup = document.getElementById('oli-chatbot-popup');
  var closeBtn = document.getElementById('oli-chatbot-close');
  var csBtn = document.getElementById('oli-chatbot-cs');
  var csIcon = document.getElementById('oli-chatbot-cs-icon');
  var csStatus = document.getElementById('oli-chatbot-cs-status');
  var resetIcon = document.getElementById('oli-greeting-back')

  if (!trigger || !popup) return;

  // Disable Kustomer CS option by default until we confirm it's available
  if (csBtn) {
    csBtn.style.display = 'none';
  }

  // Show trigger only if Oli AI is enabled or Kustomer is available
  // @ts-ignore
  if (window.OLI_VISIBLE) {
    trigger.style.display = '';
  }

  // Poll for Kustomer to load (it initialises asynchronously)
  var KUSTOMER_POLL_INTERVAL = 500; // ms
  var KUSTOMER_MAX_WAIT = 10000;    // 10 s
  var kustomerReady = false;

  function waitForKustomer(callback) {
    var elapsed = 0;
    if (window.Kustomer && typeof window.Kustomer.open === 'function') {
      kustomerReady = true;
      callback(true);
      return;
    }
    var poll = setInterval(function () {
      elapsed += KUSTOMER_POLL_INTERVAL;
      if (window.Kustomer && typeof window.Kustomer.open === 'function') {
        clearInterval(poll);
        kustomerReady = true;
        callback(true);
      } else if (elapsed >= KUSTOMER_MAX_WAIT) {
        clearInterval(poll);
        kustomerReady = false;
        callback(false);
      }
    }, KUSTOMER_POLL_INTERVAL);
  }

  // Show / hide the Kustomer iframe (chat window).
  // The iframe is hidden by default via CSS (opacity:0 + pointer-events:none)
  // so the launcher icon is invisible but the widget stays functional.
  function showKustomerChat() {
    var iframe = document.getElementById('kustomer-ui-sdk-iframe');
    if (iframe) {
      iframe.style.setProperty('opacity', '1', 'important');
      iframe.style.setProperty('pointer-events', 'auto', 'important');
    }
  }

  function hideKustomerChat() {
    var iframe = document.getElementById('kustomer-ui-sdk-iframe');
    if (iframe) {
      iframe.style.setProperty('opacity', '0', 'important');
      iframe.style.setProperty('pointer-events', 'none', 'important');
    }
  }

  // Once Kustomer is ready, show the trigger (if not already visible)
  waitForKustomer(function (ready) {
    if (ready) {
      trigger.style.display = '';
      checkKustomerAvailability();

      // Listen for Kustomer close event to re-hide the iframe
      if (window.Kustomer && typeof window.Kustomer.addListener === 'function') {
        window.Kustomer.addListener('onClose', function () {
          hideKustomerChat();
        });
      }
    } else {
      // Kustomer not available — hide the CS option entirely
      disableKustomer();

      // If Oli is also not available, hide the trigger completely
      // @ts-ignore
      if (!window.OLI_VISIBLE) {
        trigger.style.display = 'none';
      }
    }
  });

  var isOpen = false;

  function openPopup() {
    isOpen = true;
    popup.classList.add('oli-chatbot__popup--open');
    trigger.classList.add('oli-chatbot__trigger--hidden');
    trigger.setAttribute('aria-expanded', 'true');
    // Re-check only if polling has already completed; otherwise waitForKustomer handles it
    if (kustomerReady) {
      checkKustomerAvailability();
    }
  }

  function closePopup() {
    isOpen = false;
    popup.classList.remove('oli-chatbot__popup--open');
    trigger.classList.remove('oli-chatbot__trigger--hidden');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function checkKustomerAvailability() {
    if (!kustomerReady || !window.Kustomer) {
      disableKustomer();
      return;
    }

    // Widget is loaded — enable the button (Kustomer.open will work)
    enableKustomer();
  }

  function enableKustomer() {
    if (csBtn) {
      csBtn.style.display = '';
      csBtn.classList.remove('oli-chatbot__option--disabled');
      csBtn.removeAttribute('disabled');
    }
    if (csStatus) csStatus.textContent = 'Chat with our support team';
    if (csIcon) csIcon.classList.add('oli-chatbot__option-icon--enabled');
  }

  function disableKustomer() {
    if (csBtn) {
      csBtn.style.display = 'none';
      csBtn.classList.add('oli-chatbot__option--disabled');
      csBtn.setAttribute('disabled', '');
    }
  }

  // Auto-open popup once per browser session.
  // Rules:
  //   - Landing page (first page in session): never auto-open, even after 15 s.
  //   - Second page in session: auto-open after 25 s on that page.
  //   - Once auto-opened, never open again this session (session cookie guard).
  // A session cookie (no expires) clears automatically when the browser closes.
  var OLI_AUTO_POPUP_KEY = 'oli_auto_popup_shown';
  var OLI_SESSION_PAGE_COUNT_KEY = 'oli_session_page_count';
  var AUTO_POPUP_DELAY = 25000;

  /** @param {string} name @returns {string|null} */
  function getSessionCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? match[1] ?? null : null;
  }

  /** @param {string} name @param {string} value */
  function setSessionCookie(name, value) {
    document.cookie = name + '=' + value + '; path=/; SameSite=Lax';
  }
  /** @type {ReturnType<typeof setTimeout> | null} */
  var autoPopupTimer = null;
  var userHasInteracted = false;
  var pendingAutoPopup = false;

  function tryOpenAutoPopup() {
    if (userHasInteracted || isOpen || getSessionCookie(OLI_AUTO_POPUP_KEY)) return;
    // @ts-ignore — trigger null-checked at top of IIFE
    if (trigger.style.display === 'none') trigger.style.display = '';
    setSessionCookie(OLI_AUTO_POPUP_KEY, '1');
    openPopup();
  }

  function scheduleAutoPopup() {
    if (getSessionCookie(OLI_AUTO_POPUP_KEY)) return;

    // Increment the session page count; skip auto-popup on the landing page (first page).
    var pageCount = parseInt(sessionStorage.getItem(OLI_SESSION_PAGE_COUNT_KEY) || '0', 10) + 1;
    sessionStorage.setItem(OLI_SESSION_PAGE_COUNT_KEY, String(pageCount));
    if (pageCount < 2) return;

    autoPopupTimer = setTimeout(function () {
      var searchModalEl = document.getElementById('search-modal');
      var searchModalOpen = searchModalEl && searchModalEl.querySelector('dialog[open]');
      var navOverlay = document.querySelector('.gm-custom-overlay.gm-active');
      var mobileNav = document.querySelector('.menu-drawer-container.menu-open');
      if (searchModalOpen || navOverlay || mobileNav) {
        // Defer: show popup once the blocking overlay closes instead
        pendingAutoPopup = true;
        return;
      }
      tryOpenAutoPopup();
    }, AUTO_POPUP_DELAY);
  }

  // If the popup was deferred because the search modal was open, show it after it closes
  (function listenForSearchModalClose() {
    var searchModalEl = document.getElementById('search-modal');
    if (!searchModalEl) return;
    searchModalEl.addEventListener('dialog:close', function () {
      if (!pendingAutoPopup) return;
      pendingAutoPopup = false;
      setTimeout(tryOpenAutoPopup, 400);
    });
  })();

  // If the popup was deferred because the desktop nav menu was open, watch for gm-active being removed
  (function listenForNavMenuClose() {
    var navOverlay = document.querySelector('.gm-custom-overlay');
    if (!navOverlay) return;
    var observer = new MutationObserver(function () {
      if (!pendingAutoPopup) return;
      // @ts-ignore — navOverlay is non-null: guarded by the enclosing if (!navOverlay) return
      if (!navOverlay.classList.contains('gm-active')) {
        pendingAutoPopup = false;
        observer.disconnect();
        setTimeout(tryOpenAutoPopup, 400);
      }
    });
    observer.observe(navOverlay, { attributes: true, attributeFilter: ['class'] });
  })();

  // If the popup was deferred because the mobile nav drawer was open, watch for menu-open being removed
  (function listenForMobileNavClose() {
    var menuDrawer = document.querySelector('.menu-drawer-container');
    if (!menuDrawer) return;
    var observer = new MutationObserver(function () {
      if (!pendingAutoPopup) return;
      // @ts-ignore — menuDrawer is non-null: guarded by the enclosing if (!menuDrawer) return
      if (!menuDrawer.classList.contains('menu-open')) {
        pendingAutoPopup = false;
        observer.disconnect();
        setTimeout(tryOpenAutoPopup, 400);
      }
    });
    observer.observe(menuDrawer, { attributes: true, attributeFilter: ['class'] });
  })();

  scheduleAutoPopup();

  // Toggle popup on trigger click
  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    userHasInteracted = true;
    if (autoPopupTimer) {
      clearTimeout(autoPopupTimer);
      autoPopupTimer = null;
    }
    setSessionCookie(OLI_AUTO_POPUP_KEY, '1');
    isOpen ? closePopup() : openPopup();
  });

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      closePopup();
    });
  }

  // Close on outside click
  document.addEventListener('click', function (e) {
    if (!isOpen) return;
    if (!popup.contains(e.target) && !trigger.contains(e.target)) {
      closePopup();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) {
      closePopup();
    }
  });

  // Kustomer option
  if (csBtn) {
    csBtn.addEventListener('click', function () {
      if (csBtn.disabled) return;
      if (kustomerReady && window.Kustomer && typeof window.Kustomer.open === 'function') {
        showKustomerChat();
        window.Kustomer.open();
        closePopup();
      }
    });
  }

  // Oli option — opens greeting drawer (visibility controlled by olivela_ai metaobject)
  var oliBtn = document.getElementById('oli-chatbot-oli');
  if (oliBtn) {
    // @ts-ignore
    if (!window.OLI_VISIBLE) {
      oliBtn.style.display = 'none';
    } else {
      oliBtn.addEventListener('click', function () {
        openGreetingDrawer();
        closePopup();
      });
    }
  }


  // ===== Ask Oli Greeting Drawer =====

  var netlifyDomain = window.netlify_function_domain || '';
  var OLI_API_URL = netlifyDomain + '/.netlify/functions/chat-mcp-v2';

  var greetingComponent = document.getElementById('oli-greeting');
  var greetingInput = document.getElementById('oli-greeting-input');
  var greetingPrompts = document.querySelectorAll('.oli-greeting__prompt');
  var welcomeView = document.getElementById('oli-greeting-welcome');
  var chatView = document.getElementById('oli-greeting-chat');
  var messagesContainer = document.getElementById('oli-greeting-messages');

  var OLI_HISTORY_KEY = 'oli_chat_session';
  var OLI_SESSION_FLAG = 'oli_session_active';
  var OLI_NEW_TAB_KEY = 'oli_new_tab';
  var NEW_TAB_TTL_MS = 5000; // 5 seconds
  var MAX_STORED_TURNS = 20;
  var MAX_RESULTS = 10;

  var conversationHistory = [];
  var currentCursors = {};
  var lastSearchState = null;
  var messageLog = [];
  var lastQueryText = '';
  var messagesRestored = false;

  // Placeholder-to-CTA configuration for API response messages
  var OLI_CTA_MAP = {
    '[[Jewelry]]': { label: 'Ask a jewelry expert', type: 'jewelry_concierge', mailTo: 'jewelryconcierge@olivela.com' },
    '[[Jewelry_STREAK]]': { label: 'Ask a jewelry expert', type: 'jewelry_concierge', mailTo: 'jewelryconcierge@olivela.com' },
    '[[Stylist]]': { label: 'Ask a Stylist', type: 'stylist', mailTo: 'help@olivela.com' },
    '[[Stylist_STREAK]]': { label: 'Ask a Stylist', type: 'stylist', mailTo: 'help@olivela.com' },
    '[[Support]]': { label: 'Contact Customer care', type: 'customerCare', mailTo: 'help@olivela.com' },
    '[[Support_STREAK]]': { label: 'Contact Customer care', type: 'customerCare', mailTo: 'help@olivela.com' },
    '[[Shipping information]]': { label: 'Shipping information', type: 'shipping_info', link: 'https://help.olivela.com/en_us/categories/shipping-r1nyaemXA' },
    '[[Payment information]]': { label: 'Payment information', type: 'payment_info', link: 'https://help.olivela.com/en_us/categories/payment-SJllTx7XC' },
    '[[Returns and exchanges]]': { label: 'Returns and exchanges', type: 'returns_exchanges', link: 'https://help.olivela.com/en_us/categories/returns-exchanges-Sk3yalm70' }
  };
  var oliLoading = false;

  // ----- Session storage -----

  function initSession() {
    var hasFlag = sessionStorage.getItem(OLI_SESSION_FLAG);
    if (!hasFlag) {
      var newTabTs = localStorage.getItem(OLI_NEW_TAB_KEY);
      var isNewTab = newTabTs && (Date.now() - parseInt(newTabTs, 10)) < NEW_TAB_TTL_MS;
      if (isNewTab) {
        localStorage.removeItem(OLI_NEW_TAB_KEY);
      }
      sessionStorage.setItem(OLI_SESSION_FLAG, '1');
    }
  }

  function loadSession() {
    try {
      var raw = localStorage.getItem(OLI_HISTORY_KEY);
      if (!raw) return false;
      var s = JSON.parse(raw);
      if (!s.messageLog || !s.messageLog.length) return false;

      conversationHistory = s.conversationHistory || [];
      currentCursors = s.currentCursors || {};
      lastSearchState = s.lastSearchState || null;
      messageLog = s.messageLog || [];
      return true;
    } catch (e) {
      localStorage.removeItem(OLI_HISTORY_KEY);
      return false;
    }
  }

  function saveSession() {
    try {
      var trimmedLog = messageLog.slice(-(MAX_STORED_TURNS * 3));
      localStorage.setItem(OLI_HISTORY_KEY, JSON.stringify({
        conversationHistory: conversationHistory,
        currentCursors: currentCursors,
        lastSearchState: lastSearchState,
        messageLog: trimmedLog
      }));
    } catch (e) {
      localStorage.removeItem(OLI_HISTORY_KEY);
    }
  }

  // Restore previous messages into the DOM on load
  function restoreMessages() {
    if (!messageLog.length || !messagesContainer) return;
    var location = getPageLocation();
    messageLog.forEach(function (msg) {
      switch (msg.type) {
        case 'user':
          addUserMessage(msg.text, true);
          break;
        case 'assistant':
          addOliTextMessage(msg.text, true);
          break;
        case 'products':
          addProductCards(msg.products || [], location, true);
          break;
      }
    });
  }

  initSession();
  loadSession();


  // ----- Helpers -----

  function getPageLocation() {
    var path = window.location.pathname;
    if (path === '/') return 'Home';
    if (path.indexOf('/collections/') !== -1) return 'PLP';
    if (path.indexOf('/products/') !== -1) return 'PDP';
    if (path.indexOf('/designer') !== -1) return 'Designer';
    return 'Other';
  }

  function getOliPdpGaClass() {
    var path = window.location.pathname;
    if (path === '/') return 'ga-home-oli-pdp-click';
    if (path.indexOf('/collections/') !== -1) return 'ga-plp-oli-pdp-click';
    if (path.indexOf('/products/') !== -1) return 'ga-pdp-oli-pdp-click';
    if (path.indexOf('/designer') !== -1) return 'ga-designer-oli-pdp-click';
    return 'ga-oli-pdp-click';
  }

  function trackOliEvent(eventName, data) {
    document.dispatchEvent(new CustomEvent('oli:track', {
      detail: { event: eventName, data: data || {} }
    }));
  }

  // ----- View toggling -----

  function showChatView() {
    if (welcomeView) welcomeView.hidden = true;
    if (chatView) chatView.hidden = false;
    if(resetIcon) resetIcon.style.display = 'flex';
  }

  function showWelcomeView() {
    if (welcomeView) welcomeView.hidden = false;
    if (chatView) chatView.hidden = true;
    if(resetIcon) resetIcon.style.display = 'none';
  }

  function openGreetingDrawer() {
    if (!greetingComponent || typeof greetingComponent.showDialog !== 'function') return;
    if (messageLog.length > 0) {
      if (!messagesRestored) {
        messagesRestored = true;
        restoreMessages();
      }
      showChatView();
    } else {
      showWelcomeView();
    }
    greetingComponent.showDialog();
    if (greetingInput) {
      setTimeout(function () { greetingInput.focus(); }, 100);
    }
    // Trigger Nosto product recommendations
    initNostoLoad();
  }

  var nostoTriggered = false;

  function triggerNostoLoad() {
    if (nostoTriggered) return;
    if (window.nostojs) {
      window.nostojs(function (api) {
        api.loadRecommendations();
      });
      nostoTriggered = true;
      // Watch for swiper to render and wire up trackpad/wheel scrolling
      watchNostoSwiper();
    }
  }

  function watchNostoSwiper() {
    var watchTarget = document.getElementById('oli-rec-nosto');
    if (!watchTarget) return;

    // Wire up swiper wheel handler when it appears
    var swiperObserver = new MutationObserver(function () {
      var swiper = watchTarget.querySelector('swiper-container.nosto-swiper');
      if (swiper) {
        swiperObserver.disconnect();
        setTimeout(function () { attachSwiperWheelHandler(swiper); }, 800);
      }
    });
    swiperObserver.observe(watchTarget, { childList: true, subtree: true });

    var existingSwiper = watchTarget.querySelector('swiper-container.nosto-swiper');
    if (existingSwiper) {
      setTimeout(function () { attachSwiperWheelHandler(existingSwiper); }, 300);
    }
  }

  function attachSwiperWheelHandler(swiperEl) {
    if (!swiperEl || swiperEl._nostoWheelBound) return;
    swiperEl._nostoWheelBound = true;

    // Disable Swiper's built-in mousewheel module if active (prevents double-handling)
    var s0 = swiperEl.swiper;
    if (s0 && s0.mousewheel && typeof s0.mousewheel.disable === 'function') {
      s0.mousewheel.disable();
    }

    var COOLDOWN = 500;    // ms to ignore events after a slide fires
    var coolingDown = false;

    // Use CAPTURE phase + stopImmediatePropagation so Swiper's own handler never sees the event
    swiperEl.addEventListener('wheel', function (e) {
      var s = swiperEl.swiper;
      if (!s) return;
      // Only intercept dominant horizontal movement
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      // Ignore all events during cooldown
      if (coolingDown) return;

      // Any horizontal swipe triggers exactly one slide, then locks
      coolingDown = true;
      if (e.deltaX > 0) {
        s.slideNext();
      } else {
        s.slidePrev();
      }
      setTimeout(function () { coolingDown = false; }, COOLDOWN);
    }, { passive: false, capture: true });
  }

  function initNostoLoad() {
    if (window.nostojs) {
      triggerNostoLoad();
    } else {
      var poll = setInterval(function () {
        if (window.nostojs) {
          clearInterval(poll);
          triggerNostoLoad();
        }
      }, 500);
      setTimeout(function () { clearInterval(poll); }, 10000);
    }
  }

  // ----- Chat message rendering -----

  function scrollToBottom() {
    if (!messagesContainer) return;
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function formatCurrency(value, currency) {
    var num = Number(value);
    if (isNaN(num)) return value;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency', currency: currency || 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(num);
    } catch (e) {
      return '$' + (Number.isInteger(num) ? num : num.toFixed(2));
    }
  }

  function addUserMessage(text, skipLog) {
    if (!messagesContainer) return;
    var msgEl = document.createElement('div');
    msgEl.className = 'oli-greeting__msg oli-greeting__msg--user';
    msgEl.textContent = text;
    messagesContainer.appendChild(msgEl);
    scrollToBottom();
    if (!skipLog) {
      messageLog.push({ type: 'user', text: text });
    }
  }

  function getOliCtaGaClass(ctaType) {
    var path = window.location.pathname;
    var isHomePage = path === '/';
    var isDesigner = path.indexOf('/collections/designer-') !== -1;
    var isPLP = !isDesigner && path.indexOf('/collections/') !== -1;
    var isPDP = path.indexOf('/products/') !== -1;
    var isJewelry = path.indexOf('jewelry') !== -1 || path.indexOf('watches') !== -1;
    var isClothing = path.indexOf('clothing') !== -1;

    if (ctaType === 'stylist') {
      if (isPDP && isJewelry) return 'ga-oli-ask-stylist-jewelry-pdp';
      if (isPDP && isClothing) return 'ga-oli-ask-stylist-clothing-pdp';
      if (isPDP) return 'ga-oli-ask-stylist-pdp';
      if (isDesigner) return 'ga-oli-ask-stylist-designer';
      if (isPLP && isJewelry) return 'ga-oli-ask-stylist-jewelry-plp';
      if (isPLP && isClothing) return 'ga-oli-ask-stylist-clothing-plp';
      if (isPLP) return 'ga-oli-ask-stylist-plp';
      if (isHomePage) return 'ga-oli-ask-stylist-home';
    } else if (ctaType === 'customerCare') {
      if (isPDP && isJewelry) return 'ga-oli-ask-customer-care-jewelry-pdp';
      if (isPDP && isClothing) return 'ga-oli-ask-customer-care-clothing-pdp';
      if (isPDP) return 'ga-oli-ask-customer-care-pdp';
      if (isDesigner) return 'ga-oli-ask-customer-care-designer';
      if (isPLP && isJewelry) return 'ga-oli-ask-customer-care-jewelry-plp';
      if (isPLP && isClothing) return 'ga-oli-ask-customer-care-clothing-plp';
      if (isPLP) return 'ga-oli-ask-customer-care-plp';
      if (isHomePage) return 'ga-oli-ask-customer-care-home';
    } else if (ctaType === 'jewelry_concierge') {
      if (isPDP && isJewelry) return 'ga-oli-contact-a-jewelry-expert-jewelry-pdp';
      if (isPDP && isClothing) return 'ga-oli-contact-a-jewelry-expert-clothing-pdp';
      if (isPDP) return 'ga-oli-contact-a-jewelry-expert-pdp';
      if (isDesigner) return 'ga-oli-contact-a-jewelry-expert-designer';
      if (isPLP && isJewelry) return 'ga-oli-contact-a-jewelry-expert-jewelry-plp';
      if (isPLP && isClothing) return 'ga-oli-contact-a-jewelry-expert-clothing-plp';
      if (isPLP) return 'ga-oli-contact-a-jewelry-expert-plp';
      if (isHomePage) return 'ga-oli-contact-a-jewelry-expert-home';
    } else if (ctaType === 'shipping_info') {
      return 'ga-oli-shipping-info';
    } else if (ctaType === 'payment_info') {
      return 'ga-oli-payment-info';
    } else if (ctaType === 'returns_exchanges') {
      return 'ga-oli-returns-exchanges';
    }
    return '';
  }

  function handleOliCtaEmail(type, mailTo) {
    var pageTitle = document && document.title ? document.title : '';
    var searchText = lastQueryText || '';
    var url = window.location.href;
    var productName = '';
    var isPDP = window.location.pathname.indexOf('/products/') !== -1;
    if (isPDP) {
      var nameEl = document.querySelector('#productName');
      productName = nameEl ? nameEl.innerHTML : '';
    }
    var subject = '';
    var body = '';
    if (type === 'stylist') {
      subject = 'I have a question about an Olivela product';
      if (isPDP && productName) subject += ': ' + productName;
    } else if (type === 'customerCare') {
      subject = 'Olivela support query';
    } else if (type === 'jewelry_concierge') {
      subject = 'I have a question about an Olivela jewelry product';
      if (isPDP && productName) subject += ': ' + productName;
    } else {
      return;
    }
    // Build conversation history transcript
    var chatHistory = '';
    if (messageLog.length > 0) {
      chatHistory = '\n\n--- Conversation History ---\n';
      for (var i = 0; i < messageLog.length; i++) {
        var entry = messageLog[i];
        if (entry.type === 'user') {
          chatHistory += 'Customer: ' + entry.text + '\n';
        } else if (entry.type === 'assistant' && entry.text) {
          chatHistory += 'Oli: ' + entry.text + '\n';
        }
        // Skip 'products' entries — they don't have text content
      }
      chatHistory += '--- End of Conversation ---';
    }
    body = encodeURIComponent(
      'Hi there,\nI was just talking to Oli and wanted to know "' + searchText + '". \n\nHere\'s the page I was on: ' + pageTitle + '.\n\nMany thanks' + chatHistory + '\n\nReference: ' + url
    );
    window.location.href = 'mailto:' + mailTo + '?subject=' + encodeURIComponent(subject) + '&body=' + body;
  }

  function addOliTextMessage(text, skipLog) {
    if (!messagesContainer || !text) return;
    var wrapper = document.createElement('div');
    wrapper.className = 'oli-greeting__msg oli-greeting__msg--oli';

    // Check if text contains any CTA placeholders
    var hasPlaceholder = false;
    var placeholderKeys = Object.keys(OLI_CTA_MAP);
    for (var i = 0; i < placeholderKeys.length; i++) {
      if (text.indexOf(placeholderKeys[i]) !== -1) {
        hasPlaceholder = true;
        break;
      }
    }

    if (hasPlaceholder) {
      // Split text around placeholders and build mixed content
      var remaining = text;
      var fragment = document.createDocumentFragment();
      var placeholderPattern = /\[\[(Jewelry|Jewelry_STREAK|Stylist|Stylist_STREAK|Support|Support_STREAK|Shipping information|Payment information|Returns and exchanges)\]\]/g;
      var match;
      var lastIndex = 0;

      while ((match = placeholderPattern.exec(remaining)) !== null) {
        // Add text before the placeholder
        if (match.index > lastIndex) {
          var textBefore = document.createElement('p');
          textBefore.className = 'oli-greeting__msg-text';
          textBefore.textContent = remaining.substring(lastIndex, match.index);
          fragment.appendChild(textBefore);
        }
        // Add the CTA button
        var ctaConfig = OLI_CTA_MAP[match[0]];
        if (ctaConfig) {
          if (ctaConfig.link) {
            var anchor = document.createElement('a');
            var gaClass = getOliCtaGaClass(ctaConfig.type);
            anchor.className = 'btn-primary oli-greeting__cta-btn oli-contcat-placeholder' + (gaClass ? ' ' + gaClass : '');
            anchor.textContent = ctaConfig.label;
            anchor.href = ctaConfig.link;
            anchor.target = '_blank';
            anchor.rel = 'noopener noreferrer';
            anchor.setAttribute('data-oli-cta-type', ctaConfig.type);
            fragment.appendChild(anchor);
          } else {
            var btn = document.createElement('button');
            var gaClass = getOliCtaGaClass(ctaConfig.type);
            btn.className = 'btn-primary oli-greeting__cta-btn oli-contcat-placeholder' + (gaClass ? ' ' + gaClass : '');
            btn.textContent = ctaConfig.label;
            btn.setAttribute('data-oli-cta-type', ctaConfig.type);
            btn.setAttribute('data-oli-cta-mailto', ctaConfig.mailTo);
            btn.addEventListener('click', (function (type, mailTo) {
              return function () { handleOliCtaEmail(type, mailTo); };
            })(ctaConfig.type, ctaConfig.mailTo));
            fragment.appendChild(btn);
          }
        }
        lastIndex = match.index + match[0].length;
      }
      // Add any remaining text after the last placeholder
      if (lastIndex < remaining.length) {
        var textAfter = document.createElement('p');
        textAfter.className = 'oli-greeting__msg-text';
        textAfter.textContent = remaining.substring(lastIndex);
        fragment.appendChild(textAfter);
      }
      wrapper.appendChild(fragment);
    } else {
      var textEl = document.createElement('p');
      textEl.className = 'oli-greeting__msg-text';
      textEl.textContent = text;
      wrapper.appendChild(textEl);
    }

    messagesContainer.appendChild(wrapper);
    scrollToBottom();
    if (!skipLog) {
      messageLog.push({ type: 'assistant', text: text });
    }
  }

  function addLoadingMessage() {
    if (!messagesContainer) return null;
    var el = document.createElement('div');
    el.className = 'oli-greeting__msg oli-greeting__msg--oli oli-greeting__msg--loading';
    el.innerHTML =
      '<span class="oli-greeting__loading-dots">' +
        '<span></span><span></span><span></span>' +
      '</span>';
    messagesContainer.appendChild(el);
    scrollToBottom();
    return el;
  }

  function removeElement(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  // ----- Product normalization (handles various API shapes) -----

  function normalizeProduct(p) {
    // Handles price_range.min/max as either:
    //   { amount: 28000, currency: "USD" }  ← new UCP format (cents)
    //   280.00                              ← old flat format (dollars)
    function parsePriceField(val) {
      if (!val && val !== 0) return NaN;
      if (typeof val === 'object' && val.amount != null) return val.amount / 100;
      return parseFloat(val);
    }

    var priceMin = p.price_range && p.price_range.min;
    var priceMax = p.price_range && p.price_range.max;

    var price = priceMin
      ? parsePriceField(priceMin)
      : (p.price ? parseFloat(p.price) : 0);

    var maxVal = priceMax ? parsePriceField(priceMax) : NaN;
    var compareAtPrice = (!isNaN(maxVal) && maxVal > price)
      ? maxVal
      : (p.compareAtPrice || p.compare_at_price
          ? parseFloat(p.compareAtPrice || p.compare_at_price)
          : null);

    // UCP nests currency inside price_range.min; legacy had it flat on price_range
    var currency = (p.price_range && p.price_range.min && p.price_range.min.currency)
      || (p.price_range && p.price_range.currency)
      || p.currency
      || 'USD';

    var image = p.image_url
      || (p.images && p.images[0])
      || p.image
      || '';

    var url = p.url
      || (p.handle ? '/products/' + p.handle : '#');

    var rawId = String(p.id || p.admin_graphql_api_id || p.product_id || p.gid || '');

    return {
      title: p.title || 'Untitled',
      vendor: p.vendor || '',
      price: price,
      compareAtPrice: compareAtPrice,
      currency: currency,
      image: image,
      url: url,
      handle: p.handle || '',
      available: p.available !== false,
      variants: p.variants || [],
      id: rawId
    };
  }


  // ----- Product card strip (horizontal scroll) -----

  function addProductCards(rawProducts, location, skipLog) {
    if (!messagesContainer || !rawProducts || !rawProducts.length) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'oli-greeting__msg oli-greeting__msg--oli oli-greeting__msg--products';

    var cardsWrap = document.createElement('div');
    cardsWrap.className = 'oli-greeting__cards-wrap';

    var btnLeft = document.createElement('button');
    btnLeft.className = 'oli-greeting__scroll-btn oli-greeting__scroll-btn--left oli-greeting__scroll-btn--hidden';
    btnLeft.innerHTML = '<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 1L1 6L6 11" stroke="#111111" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    btnLeft.setAttribute('aria-label', 'Scroll left');
    btnLeft.type = 'button';

    var btnRight = document.createElement('button');
    btnRight.className = 'oli-greeting__scroll-btn oli-greeting__scroll-btn--right';
    btnRight.innerHTML = '<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L1 11" stroke="#111111" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    btnRight.setAttribute('aria-label', 'Scroll right');
    btnRight.type = 'button';

    var strip = document.createElement('div');
    strip.className = 'oli-greeting__cards-strip';

    var oliPdpGaClass = getOliPdpGaClass();

    rawProducts.forEach(function (rawProduct) {
      var p = normalizeProduct(rawProduct);

      var card = document.createElement('a');
      card.className = 'oli-greeting__card';
      var cardUrl = new URL(p.url, window.location.origin);
      cardUrl.searchParams.set('search_source', 'oli_pdp');
      card.href = cardUrl.toString();
      card.target = '_blank';
      card.rel = 'noopener';

      // Image wrapper
      var imgWrap = document.createElement('div');
      imgWrap.className = 'oli-greeting__card-img-wrap';
      if (p.image) {
        var img = document.createElement('img');
        img.src = p.image;
        img.alt = p.title;
        img.loading = 'lazy';
        img.classList.add(oliPdpGaClass);
        imgWrap.appendChild(img);
      }

      card.appendChild(imgWrap);

      // Card body
      var body = document.createElement('div');
      body.className = 'oli-greeting__card-body';

      if (p.vendor) {
        var brand = document.createElement('div');
        brand.className = 'oli-greeting__card-brand ' + oliPdpGaClass;
        brand.textContent = p.vendor.toUpperCase();
        body.appendChild(brand);
      }

      var title = document.createElement('div');
      title.className = 'oli-greeting__card-title ' + oliPdpGaClass;
      title.textContent = p.title;
      body.appendChild(title);

      var prices = document.createElement('div');
      prices.className = 'oli-greeting__card-prices ' + oliPdpGaClass;
      if (p.compareAtPrice && p.compareAtPrice > p.price) {
        var compareEl = document.createElement('span');
        compareEl.className = 'oli-greeting__card-compare';
        compareEl.textContent = formatCurrency(p.compareAtPrice, p.currency);
        prices.appendChild(compareEl);

        var saleEl = document.createElement('span');
        saleEl.className = 'oli-greeting__card-sale';
        saleEl.textContent = formatCurrency(p.price, p.currency);
        prices.appendChild(saleEl);
      } else {
        var priceEl = document.createElement('span');
        priceEl.className = 'oli-greeting__card-price';
        priceEl.textContent = formatCurrency(p.price, p.currency);
        prices.appendChild(priceEl);
      }
      body.appendChild(prices);
      card.appendChild(body);

      // Track PDP click (navigation handled by <a> href)
      card.addEventListener('click', function () {
        localStorage.setItem(OLI_NEW_TAB_KEY, Date.now().toString());
        trackOliEvent(location + ' - Oli PDP click', {
          product_id: p.id,
          product_url: p.url
        });
      });

      strip.appendChild(card);
    });

    function updateArrows() {
      var atStart = strip.scrollLeft <= 4;
      var atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
      btnLeft.classList.toggle('oli-greeting__scroll-btn--hidden', atStart);
      btnRight.classList.toggle('oli-greeting__scroll-btn--hidden', atEnd || rawProducts.length <= 3);
    }

    btnLeft.addEventListener('click', function () { strip.scrollBy({ left: -300, behavior: 'smooth' }); });
    btnRight.addEventListener('click', function () { strip.scrollBy({ left: 300, behavior: 'smooth' }); });
    strip.addEventListener('scroll', updateArrows);

    cardsWrap.appendChild(btnLeft);
    cardsWrap.appendChild(strip);
    cardsWrap.appendChild(btnRight);
    wrapper.appendChild(cardsWrap);

    messagesContainer.appendChild(wrapper);
    requestAnimationFrame(updateArrows);
    scrollToBottom();

    if (!skipLog) {
      var slimProducts = rawProducts.map(function (rp) {
        var n = normalizeProduct(rp);
        return {
          title: n.title, vendor: n.vendor, price: n.price,
          compareAtPrice: n.compareAtPrice, currency: n.currency,
          image: n.image, url: n.url, handle: n.handle, id: n.id
        };
      });
      messageLog.push({ type: 'products', products: slimProducts });
    }
  }

  // ----- Product filtering -----

  function filterProducts(products, query) {
    if (!products || !products.length) return [];

    var sizeMatch = query.match(/\bsize\s+(\S+)/i);
    var requestedSize = sizeMatch ? sizeMatch[1].toLowerCase() : null;

    var filtered = products.filter(function (product) {
      if (product.available === false) return false;

      if (requestedSize && product.variants && product.variants.length) {
        var hasSizeInStock = product.variants.some(function (v) {
          var variantTitle = (v.title || '').toLowerCase();
          return variantTitle.indexOf(requestedSize) !== -1 && v.available;
        });
        if (!hasSizeInStock) return false;
      }

      return true;
    });

    return filtered.slice(0, MAX_RESULTS);
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[$()*+./?[\\\]^{|}-]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function getGA4SessionId() {
    // adjust if your env flag is exposed differently in theme runtime
    var gaCookieName = window.APP_MODE === 'production' ? '_ga_7YBDDD5RP7' : '_ga_EZQ6LM9EQB';
    var gaCookie = getCookie(gaCookieName);
    if (!gaCookie) return null;

    var parts = gaCookie.split('.');
    if (parts.length > 2 && parts[2]) {
      var sessionPart = parts[2].split('$')[0];
      if (sessionPart && sessionPart.length > 1) {
        return sessionPart.substring(1);
      }
    }
    return null;
  }

  function getLoggedInCustomerId() {
    // set this in Liquid globally if available: window.CUSTOMER_ID = "{{ customer.id }}";
    return window.CUSTOMER_ID || null;
  }

  function getDeviceType() {
    var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    return isMobile ? 'mobile' : isDesktop ? 'desktop' : 'unknown';
  }

  // ----- API call -----

  function callOliAPI(query) {
    var payload = {
      message: query,
      conversationHistory: conversationHistory,
      cursors: currentCursors,
      lastSearchState: query === 'show me more' ? lastSearchState : null,
      device: getDeviceType(),
      url: typeof window !== "undefined" ? window.location.href : "",
      pageContext: window.oliPageContext || null
    };

    // Send extra fields only for logged-in user
    if (window.IS_LOGGED_IN) {
      var customerId = getLoggedInCustomerId();
      if (customerId) payload.user_id = String(customerId);
    }

    var gaSessionId = getGA4SessionId();
    if (gaSessionId) payload.ga_session_id = gaSessionId;



    return fetch(OLI_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('API request failed');
      return res.json();
    });
  }

  // ----- Send query -----

  function sendOliQuery(isPreset) {
    if (!greetingInput || oliLoading) return;
    var query = greetingInput.value.trim();
    if (!query) return;

    oliLoading = true;
    lastQueryText = query;
    var location = getPageLocation();

    // Tracking
    if (isPreset) {
      trackOliEvent('Oli preset search click', { query: query });
    } else {
      trackOliEvent(location + ' - Oli search CTA click', { query: query });
    }

    showChatView();
    addUserMessage(query);
    greetingInput.value = '';

    var loadingEl = addLoadingMessage();

    callOliAPI(query)
      .then(function (data) {
        removeElement(loadingEl);

        // Update state from API response
        conversationHistory = data.nextHistory || conversationHistory;
        currentCursors = data.nextCursors || {};

        if (data.intent !== 'show_more' && data.lastSearchState) {
          lastSearchState = data.lastSearchState;
        } else if (data.intent !== 'show_more') {
          lastSearchState = null;
        }

        // Route by intent
        var responseText = data.responseText || data.message || '';
        var products = filterProducts(data.products || [], query);

        if (responseText) {
          addOliTextMessage(responseText);
        }

        if (products.length) {
          addProductCards(products, location);
        }

        saveSession();
      })
      .catch(function () {
        removeElement(loadingEl);
        addOliTextMessage('Sorry, I encountered an error. Please try again.');
        saveSession();
      })
      .finally(function () {
        oliLoading = false;
        if (greetingInput) greetingInput.focus();
      });
  }

  // ----- Event listeners -----

  // Preset prompt clicks — submit the prompt text immediately
  greetingPrompts.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!greetingInput) return;
      greetingInput.value = btn.dataset.prompt || '';
      sendOliQuery(true);
    });
  });

  // Send on Enter
  if (greetingInput) {
    greetingInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        sendOliQuery(false);
      }
    });
  }

  // Send button
  var sendBtn = document.getElementById('oli-greeting-send');
  if (sendBtn) {
    sendBtn.addEventListener('click', function () {
      sendOliQuery(false);
    });
  }

  // Close button
  var greetingCloseBtn = document.getElementById('oli-greeting-close');
  if (greetingCloseBtn && greetingComponent) {
    greetingCloseBtn.addEventListener('click', function () {
      if (typeof greetingComponent.closeDialog === 'function') {
        greetingComponent.closeDialog();
      }
    });
  }

  // Back button — reset chat and return to welcome view
  var greetingBackBtn = document.getElementById('oli-greeting-back');
  if (greetingBackBtn) {
    greetingBackBtn.addEventListener('click', function () {
      // Clear conversation state
      conversationHistory = [];
      currentCursors = {};
      lastSearchState = null;
      messageLog = [];
      localStorage.removeItem(OLI_HISTORY_KEY);

      // Clear rendered messages
      if (messagesContainer) messagesContainer.innerHTML = '';

      showWelcomeView();
    });
  }

  // ===== ADA: Focus trap inside greeting dialog =====
  if (greetingComponent) {
    var greetingDialog = greetingComponent.querySelector('dialog');
    if (greetingDialog) {
      greetingDialog.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;

        var focusableEls = greetingDialog.querySelectorAll(
          'button:not([disabled]):not([tabindex="-1"]), ' +
          'input:not([disabled]):not([tabindex="-1"]), ' +
          'a[href]:not([tabindex="-1"]), ' +
          '[tabindex="0"]'
        );
        if (!focusableEls.length) return;

        var firstEl = focusableEls[0];
        var lastEl = focusableEls[focusableEls.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstEl) {
            e.preventDefault();
            lastEl.focus();
          }
        } else {
          if (document.activeElement === lastEl) {
            e.preventDefault();
            firstEl.focus();
          }
        }
      });
    }
  }

})();